<ion-grid class="bg-white rounded-lg font-sans" style="padding: 20px">
	<ion-row>
		<ion-col size="12">
			<div class="text-2xl text-center pb-20 font-bold">
				New to Terra.do? Sign up
			</div>
			<ion-button
				class="font-sans text-xl h-50 google-sign-in"
				expand="full"
				(click)="signupUsingGoogle($event)"
			>
				<ion-icon name="logo-google" style="margin-right: 15px"></ion-icon>
				Sign up with Google
			</ion-button>
			<div class="my-24">
				<div class="seperator"></div>
				<div class="seperatorText text-center">Or</div>
				<div class="seperator"></div>
			</div>
			<form [formGroup]="signUpForm" (ngSubmit)="onSubmit(signUpForm)">
				<ion-item class="signupFormItem leading-6" lines="full">
					<ion-label position="floating">Name</ion-label>
					<ion-input formControlName="name" type="text"></ion-input>
				</ion-item>

				<ng-container *ngFor="let validation of signUpFormErrorMessages.name">
					<div
						class="errorMessageClass flex items-center mb-12"
						*ngIf="
							signUpForm.get('name')?.hasError(validation.type) &&
							(signUpForm.get('name')?.dirty || signUpForm.get('name')?.touched)
						"
					>
						<ion-icon name="close-circle" class="text-rose-600"></ion-icon>
						<span class="text-rose-600 ml-8 mt-2">{{
							validation.message
						}}</span>
					</div>
				</ng-container>

				<ion-item class="signupFormItem leading-6" lines="full">
					<ion-label position="floating">Email</ion-label>
					<ion-input formControlName="email" type="text"></ion-input>
				</ion-item>
				<ng-container *ngFor="let validation of signUpFormErrorMessages.email">
					<div
						class="errorMessageClass flex items-center mb-12"
						*ngIf="
							signUpForm.get('email')?.hasError(validation.type) &&
							(signUpForm.get('email')?.dirty ||
								signUpForm.get('email')?.touched)
						"
					>
						<ion-icon name="close-circle" class="text-rose-600"></ion-icon>
						<span class="text-rose-600 ml-8 mt-2">{{
							validation.message
						}}</span>
					</div>
				</ng-container>

				<ion-item class="signupFormItem leading-6" lines="full">
					<ion-label position="floating">Password</ion-label>
					<ion-input formControlName="password" type="password"></ion-input>
				</ion-item>
				<ng-container
					*ngFor="let validation of signUpFormErrorMessages.password"
				>
					<div
						class="errorMessageClass flex items-center mb-12"
						*ngIf="
							signUpForm.get('password')?.hasError(validation.type) &&
							(signUpForm.get('password')?.dirty ||
								signUpForm.get('password')?.touched)
						"
					>
						<ion-icon name="close-circle" class="text-rose-600"></ion-icon>
						<span class="text-rose-600 ml-8 mt-2">{{
							validation.message
						}}</span>
					</div>
				</ng-container>
				<ion-item lines="none" text-wrap>
					<ion-checkbox
						style="margin-right: 10px"
						slot="start"
						checked="false"
						formControlName="subscribeNewsLetter"
					></ion-checkbox>
					<ion-label style="font-size: 15px" text-wrap
						>Subscribe to our newsletter.<br />Two minutes of climate knowledge
						each weekday</ion-label
					>
				</ion-item>
				<ion-item lines="none" text-wrap>
					<ion-checkbox
						style="margin-right: 10px"
						slot="start"
						checked="false"
						formControlName="agreeTerms"
					>
					</ion-checkbox>
					<ion-label style="font-size: 15px" text-wrap
						>I agree that I have read, consent and agree to the
						<a href="https://www.terra.do/terms-of-services/" target="_blank"
							>Terms of Services</a
						>
						and
						<a href="https://www.terra.do/media-release" target="_blank"
							>Media Release</a
						>.*
					</ion-label>
				</ion-item>
				<ion-item lines="none" text-wrap>
					<ion-checkbox
						style="margin-right: 10px"
						slot="start"
						checked="false"
						formControlName="agreePolicy"
					></ion-checkbox>
					<ion-label style="font-size: 15px" text-wrap
						>I agree that I have read, consent and agree to the
						<a href="https://www.terra.do/privacy-policy/" target="_blank"
							>Privacy Policy</a
						>.*</ion-label
					>
				</ion-item>
				<ion-row>
					<ion-col>
						<button
							ion-button
							class="yellowButton rounded-md h-50 text-xl w-full ion-activatable ripple-parent"
							type="submit"
						>
							Create Account
							<ion-spinner *ngIf="isLoading"></ion-spinner>

							<ion-ripple-effect></ion-ripple-effect>
						</button>
					</ion-col>
				</ion-row>
			</form>
		</ion-col>
	</ion-row>
	<ion-row class="mt-20">
		<ion-col class="forgotContainer">
			<div class="text-lg">
				Already have an account?
				<a
					class="text-blue-600 cursor-pointer"
					(click)="authService.redirectAuth('login')"
					>Sign in</a
				>
			</div>
		</ion-col>
	</ion-row>
</ion-grid>
